import styled from "styled-components";
import { Colors } from "../../config";
import Box from "../Box";
import Checkbox from "../Checkbox";

const AcknowledgementBox = () => {
  return (
    <Box boxPadding="1.188rem 1.813rem 0.875rem">
      <CheckboxWrapper>
        <Checkbox
          label="I certify that the information provided above is all correct"
          fontSize="1rem"
          fontWeight="600"
          fontColor={Colors.brandTwo}
        />
      </CheckboxWrapper>
    </Box>
  );
};

const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export default AcknowledgementBox;
